<template>
  <div class="box" v-loading="loading">
    <div class="login_title">
      <el-button v-if="activeName !== 'forget'"  type="text" size="medium" @click="handleClick('login')" style="margin-right: 0.38rem" :class="['tab-btn', 'tab', loginClass]">{{$t('m.login')}}</el-button>
      <el-button v-if="activeName !== 'forget'" type="text" size="medium" @click="handleClick('reg')" :class="['tab-btn', 'tab', regClass]">{{$t('m.reg')}}</el-button>
      <el-button type="text" size="medium" @click="handleClick('forget')" :class="['tab-btn', 'tab', forgetClass]" v-if="activeName === 'forget'">{{$t('m.forget_pwd')}}</el-button>
    </div>
    <login-tab v-if="activeName === 'login'" ref="login" @showForget="showForget" :agreeXieyi="agreeXieyi"/>
    <reg-tab v-if="activeName === 'reg'" ref="reg" :agreeXieyi="agreeXieyi"/>
    <forget-pwd v-if="activeName === 'forget'" ref="forget" @cancelPwd="cancelPwd"/>
  </div>
</template>

<script>
  import loginTab from "@/components/login/loginTab";
  import regTab from "@/components/login/regTab";
  import forgetPwd from "@/components/login/forgetPwd";

  export default {
    name: "loginRegisterTab",
    components: {loginTab, regTab, forgetPwd},
    props:{
      agreeXieyi: {
        type: Boolean,
        default () {
          return false;
        }
      },
    },
    data() {
      return {
        loading: false,
        activeName: 'login',
        loginClass: 'tab-login',
        regClass: '',
        forgetClass: '',
        beforeActiveName: 'login',
      }
    },
    methods: {
      cancelPwd() {
        this.handleClick('login')
        this.$emit('hide', false)
      },
      showForget(data) {
        console.log(data)
        this.handleClick('forget')
        this.$emit('hide', true)
      },
      handleClick(tab) {
        console.log(tab)
        if(this.beforeActiveName === tab) {
          return
        }
        this.beforeActiveName = tab
        this.activeName = tab
        this.$nextTick(() => {
          // 样式变换
          if(tab === 'login') {
            this.loginClass = 'tab-login'
            this.regClass = ''
            this.forgetClass = ''
            console.log(this.$refs)
            this.$refs.login.showTab()
          } else if(tab === 'reg'){
            this.loginClass = ''
            this.forgetClass = ''
            this.regClass = 'tab-reg'
            this.$refs.reg.showTab()
          } else{
            this.loginClass = ''
            this.regClass = ''
            this.forgetClass = 'tab-forget'
            this.$refs.forget.showTab()
          }
        })
      }
    },
    mounted() {
      console.log("login mounted")
      console.log(this.$route.query.inviteCode);
      if (this.$route.query.inviteCode) {
        this.handleClick('reg')
      }
      this.$refs.login.showTab()
    }
  }
</script>

<style lang="less">
  .tab-btn {
    color: #928e8e !important;
  }
  .tab {
    cursor: pointer !important;;
    font-size: 0.3rem !important;;
  }
  .tab:hover {
    font-weight: 500 !important;;
  }
  .tab-login {
    color: #008AFF !important;
  }
  .tab-reg {
    color: #008AFF !important;
  }
  .tab-forget {
    color: #008AFF !important;
  }

  .box {
    font-size: .14rem;
    width: 80%;
    max-width: 400px;
    margin: 0 auto;
  }

  .login {
    &_title {
      font-size: .36rem;
      text-align: center;
      padding: .67rem 0 .18rem;
    }
  }

  @media only screen and (max-width: 767px) {
    .login_title {
      padding: .38rem 0 .18rem;
      font-size: .4rem;

      &_sm {
        font-size: .32rem;
        margin-bottom: 0;
      }
    }

    .login_btn, .login_info .form_item p, .login_info .login_input, .changetxt {
      font-size: .26rem !important;
    }
  }

  @media only screen and (max-width: 540px) {
    input::-ms-input-placeholder {
      font-size: .24rem;
    }

    input::-webkit-input-placeholder {
      font-size: .24rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/loginRegisterTab.vue